// Click-to-edit inline title. Renders as plain text; click flips to input.
// Enter or blur commits (trims, ignores if unchanged). Esc cancels.

import { useState, useEffect, useRef } from 'react';

export function EditableTitle({ value, onCommit, className = '', style = {} }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!editing) setDraft(value);
  }, [value, editing]);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  function commit() {
    const t = draft.trim();
    if (t && t !== value) onCommit(t);
    setEditing(false);
  }

  function cancel() {
    setDraft(value);
    setEditing(false);
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        className={`v2-title-input ${className}`}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') { e.preventDefault(); commit(); }
          else if (e.key === 'Escape') { e.preventDefault(); cancel(); }
        }}
        style={{
          fontFamily: 'var(--ff-serif)',
          fontStyle: 'italic',
          fontSize: 'inherit',
          border: '1px solid var(--accent-sage)',
          borderRadius: 2,
          padding: '1px 4px',
          background: 'var(--paper)',
          color: 'var(--ink)',
          outline: 'none',
          boxShadow: '0 0 0 2px oklch(0.55 0.08 145 / 0.18)',
          ...style,
        }}
      />
    );
  }

  return (
    <span
      className={`v2-title-edit ${className}`}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); setEditing(true); }}
      title="click to rename"
      style={{
        fontFamily: 'var(--ff-serif)',
        fontStyle: 'italic',
        cursor: 'text',
        ...style,
      }}
    >
      {value}
    </span>
  );
}
